import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledKpiInfoIcon = styled(InfoCircleOutlined)`
    color: ${({ theme }) => theme.colors.green};
    cursor: pointer;
`;

export const StyledMainKpiValue = styled.span`
    color: ${({ theme }) => theme.colors.green};
`;

export const StyledTooltipValue = styled.p`
    color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
    margin: 0;
`;

export const StyledTooltipLabel = styled.span`
    color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
    opacity: 0.7;
`;
